@if (site) {
<label class='flex flex-middle'>
    @if (!onlyIcon) {
    <p class="p1 m-r-2">{{site.name}}</p>
    }
    <multisite-flag class="inline-flex"
                    [simpleMultisite]="true"
                    [siteId]="site.siteId"></multisite-flag>
</label>
}
